import { createActionName } from "redux/utility"

export const reducerName = "policies"

export const POLICY = createActionName(reducerName, "POLICY")

/// FSC
export const USERSE = createActionName(reducerName, "USERSE")
